import React from "react"
import { TableCell, TableRow, Typography } from "@mui/material"
import { useStyles } from "../styles"

type Props = {
  text?: string
  columns: number
}

const EmptyPlaceholder: React.FC<Props> = ({ text, columns }) => {
  const { cx, classes } = useStyles()

  return (
    <TableRow
      className={classes.row}
      data-autiomation-id="data-table-row"
      component="div"
      role="row"
    >
      <TableCell
        component="div"
        role="cell"
        colSpan={columns}
        className={cx(classes.bodyTableCell, classes.tableCell)}
        data-autiomation-id="data-table-placeholder"
      >
        <Typography
          variant="body2"
          role="alert"
          aria-live="assertive"
          aria-atomic="true"
          className={classes.emptyPlaceholder}
        >
          {text || "No Records"}
        </Typography>
      </TableCell>
    </TableRow>
  )
}

export default EmptyPlaceholder
